/**
 * MuscleToneCard — един общ показател за мускулен тонус (Nerve2):
 * скованост + бруксизъм + крампи + електролити + автономен баланс.
 */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Waves } from "lucide-react";

const BAND = { green: "#22C55E", yellow: "#EAB308", orange: "#F97316", red: "#EF4444" };

export const MuscleToneCard = ({ d, cardCls, border, isDark }) => {
  const t = d?.muscle_tone;
  if (!t) return null;
  return (
    <div className={cardCls} data-testid="neuro-tone-card">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="min-w-0">
          <div className="text-sm font-bold inline-flex items-center gap-1.5">
            <Waves className="w-4 h-4 text-violet-500" /> Мускулен тонус — един показател
          </div>
          <p className="text-[12px] opacity-80 mt-1" data-testid="neuro-tone-summary">
            {t.summary_bg}
          </p>
          <p className="text-[11px] opacity-70 mt-1">{t.explain_bg}</p>
        </div>
        <div className="text-right shrink-0">
          <div className="text-3xl font-extrabold tabular-nums"
            style={{ color: BAND[t.band] }} data-testid="neuro-tone-score">{t.score}</div>
          <div className="text-[10px] opacity-70">от 100</div>
        </div>
      </div>

      {t.drivers?.length > 0 && (
        <div className="mt-3 space-y-1.5" data-testid="neuro-tone-drivers">
          {t.drivers.map((x) => (
            <div key={x.key} className={`p-2 rounded-lg border ${border}`}
              data-testid={`neuro-tone-driver-${x.key}`}>
              <div className="text-[12px] font-bold">{x.label_bg}</div>
              <div className="text-[11px] opacity-80">{x.text_bg}</div>
            </div>
          ))}
        </div>
      )}

      <div className="mt-3" data-testid="neuro-tone-levers">
        <div className="text-[11px] font-bold">Какво сваля тонуса</div>
        <ul className="mt-1 space-y-1">
          {t.levers.map((x, i) => (
            <li key={i} className="text-[11px]">
              <span className="font-bold">{x.title_bg}</span>
              <span className="opacity-80"> — {x.why_bg}</span>
            </li>
          ))}
        </ul>
      </div>

      {t.links?.map((l, i) => (
        <div key={i} className={`mt-2 p-2 rounded-lg border ${border}`}
          data-testid={`neuro-tone-link-${l.twin}`}>
          <div className="text-[11px] font-bold">{l.title_bg}</div>
          <div className="text-[10px] opacity-85">{l.why_bg}</div>
          <div className="text-[10px] font-medium mt-0.5">{l.action_bg}</div>
          <Link to={l.route}
            className="text-[10px] font-bold text-violet-600 dark:text-violet-300 inline-flex items-center gap-1 mt-0.5"
            data-testid={`neuro-tone-cta-${l.twin}`}>
            Отвори {l.twin_bg} <ArrowRight className="w-3 h-3" />
          </Link>
        </div>
      ))}

      {t.gaps_bg?.map((g, i) => (
        <p key={i} className={`text-[11px] mt-2 ${isDark ? "opacity-70" : "opacity-75"}`}
          data-testid="neuro-tone-gap">{g}</p>
      ))}
    </div>
  );
};

export default MuscleToneCard;
